import React, { useState, useEffect } from "react";
import "./paginator.scss"; // Asegúrate de importar los estilos
import { useContext } from "react";
import { DarkModeContext } from "../../context/darkModeContext";

export const Paginator = ({
  numPagina,
  setNumPagina,
  totalPages,
  filas,
  setFilas,
  totalDataItems,
}) => {
  const [elementos, setElementos] = useState(filas);
  const [irPagina, setIrPagina] = useState(numPagina); // Estado para el selector de página
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768); // Detectar pantalla pequeña inicialmente
  const { darkMode } = useContext(DarkModeContext);

  useEffect(() => {
    // Sincronizar irPagina con numPagina cuando cambie
    setIrPagina(numPagina);
  }, [numPagina]);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 768); // Actualizar el estado según el tamaño de la pantalla
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handlePrevious = () => {
    if (numPagina > 1) setNumPagina(numPagina - 1);
  };

  const handleNext = () => {
    if (numPagina < totalPages) setNumPagina(numPagina + 1);
  };

  const renderPageNumbers = () => {
    const pageNumbers = [];
    const maxPagesToShow = isSmallScreen ? 1 : 3;

    let startPage = Math.max(numPagina - Math.floor(maxPagesToShow / 2), 1);
    let endPage = Math.min(startPage + maxPagesToShow - 1, totalPages);

    if (endPage - startPage < maxPagesToShow - 1) {
      startPage = Math.max(endPage - maxPagesToShow + 1, 1);
    }

    if (!isSmallScreen && numPagina > 3) {
      pageNumbers.push(
        <button
          key={1}
          onClick={() => setNumPagina(1)}
          className={numPagina === 1 ? "active" : ""}
        >
          1
        </button>
      );
    }

    if (!isSmallScreen && startPage > 2) {
      pageNumbers.push(<span key="start-ellipsis">...</span>);
    }

    for (let i = startPage; i <= endPage; i++) {
      if (i === numPagina) {
        pageNumbers.push(
          <div key={i} className="current-page-wrapper">
            <input
              type="number"
              value={irPagina}
              onChange={(e) => setIrPagina(Number(e.target.value))}
              onBlur={() => {
                if (irPagina >= 1 && irPagina <= totalPages) {
                  setNumPagina(irPagina);
                } else {
                  setIrPagina(numPagina); // Reiniciar al número actual si es inválido
                }
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter" && irPagina >= 1 && irPagina <= totalPages) {
                  setNumPagina(irPagina);
                }
              }}
              min="1"
              max={totalPages}
              className="current-page-input"
            />
            <button
              onClick={() => setNumPagina(irPagina)}
              className="current-page-button"
            >
              Ir
            </button>
          </div>
        );
      } else {
        pageNumbers.push(
          <button
            key={i}
            onClick={() => setNumPagina(i)}
            className={numPagina === i ? "active" : ""}
          >
            {i}
          </button>
        );
      }
    }

    if (!isSmallScreen && endPage < totalPages - 1) {
      pageNumbers.push(<span key="end-ellipsis">...</span>);
    }

    if (!isSmallScreen && totalPages > 1 && numPagina < totalPages - 2) {
      pageNumbers.push(
        <button
          key={totalPages}
          onClick={() => setNumPagina(totalPages)}
          className={numPagina === totalPages ? "active" : ""}
        >
          {totalPages}
        </button>
      );
    }

    return pageNumbers;
  };

  const handleRowsPerPageChange = (e) => {
    const newSize = Number(e.target.value);
    setFilas(newSize);
    setElementos(newSize);
    setNumPagina(1); // Reiniciar a la página 1 cuando cambian las filas
  };

  return (
    <div className={`paginator ${darkMode ? "dark" : ""}`}>
      <div className="pageSizeSelector">
        <label htmlFor="rowsPerPage">Items: </label>
        <select
          id="rowsPerPage"
          value={elementos}
          onChange={handleRowsPerPageChange}
          style={{ width: 60 }}
        >
          <option value={5}>5</option>
          <option value={10}>10</option>
          <option value={15}>15</option>
          <option value={20}>20</option>
          <option value={25}>25</option>
          <option value={50}>50</option>
          <option value={100}>100</option>
        </select>
      </div>

      <div className="pageControls">
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <button
            onClick={handlePrevious}
            disabled={numPagina === 1}
            className="page-button"
          >
            &lt;
          </button>
          {renderPageNumbers()}
          <button
            onClick={handleNext}
            disabled={numPagina === totalPages}
            className="page-button"
          >
            &gt;
          </button>
        </div>
      </div>

      <div className="totalItems">
        <label>Total de ítems:</label> {totalDataItems}
      </div>
    </div>
  );
};

export default Paginator;
